import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import toDollars from 'utils/to-dollars';

import { TIMESHEET_HOLIDAYS_MULTIPLIER } from 'services/timesheetHolidays/constants';
import TimesheetHolidayGate from 'components/TimesheetHolidayGate';
import { AppState } from 'services/types';

// Selectors
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';
import { EntityId } from 'services/entities/types';
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface OwnProps {
    timesheetEntryUuid: string;
}

interface ConnectedProps {
    earnings?: number;
    entityId: EntityId;
    date: TimesheetHolidayDate;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetEntryEarningsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { earnings, date, entityId } = this.props;
        if (!earnings) return null;

        return (
            <TimesheetHolidayGate
                fallback={toDollars(earnings)}
                timesheetDate={date}
                timesheetEntityId={entityId}
            >
                {toDollars(earnings * TIMESHEET_HOLIDAYS_MULTIPLIER)}
            </TimesheetHolidayGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    earnings: makeSelectTimesheetEntryValue('earnings'),
    entityId: makeSelectTimesheetEntryValue('entityId'),
    date: makeSelectTimesheetEntryValue('date')
});

export default connect(mapStateToProps)(TimesheetEntryEarningsComponent);
